import { SxProps } from "@mui/material";

export const tableButtonStyle: SxProps = {
  color: "#676767",
  opacity: "1",
  textTransform: "none",
};
